
import { textTemplate } from '~/helpers/util'

export default {
  name: "SectionOffer",
  props: {
    orderNo: {
      required: true,
      type: Number,
      default: 0,
    },
    hash: {
      required: true,
      type: String,
      default: ""
    },
    offer: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    data: {
      required: true,
      type: Array,
      default: function () {
        return []
      },
    }
  },
  computed: {
    offerDetails() {
      if (!this.offer) return [];
      const offerDetails = [];
      const offerFields = [];
      Object.keys(this.offer).filter(k => [
        'surface',
        'floor',
        'parking_spaces',
        'storage_spaces',
        'lease_term',
        'base_rent_office',
        'incentive_free_months',
        'base_rent_parking_interior',
        'base_rent_parking_exterior',
        'handover_date',
        'floorNumbersContainingAvailableSpaces'
      ].includes(k)).forEach((key) => {
        let type;
        switch(key) {
          case 'handover_date':
            type = 'Date';
            break;
          case 'floorNumbersContainingAvailableSpaces':
            type = 'Array';
            break;
          default:
            type = 'Text';
            break;
        }
        offerFields.push({
          literal: key,
          value: this.offer[key],
          type
        })
      })
      this.$props.data.forEach((detail) => {
        let text = '';
        if (Array.isArray(detail.templateText)) {
          text = [];
          detail.templateText.forEach((t) => {
            text.push(textTemplate.replace(t, offerFields));
          });
        } else {
          text = textTemplate.replace(detail.templateText, offerFields)
        }
        const obj = {
          label: detail.label,
          text
        }
        offerDetails.push(obj);
      });
      return offerDetails;
    }
  }
}
